import { render, staticRenderFns } from "./BuilderViewer.vue?vue&type=template&id=0e8de7fe&scoped=true&"
import script from "./BuilderViewer.vue?vue&type=script&lang=js&"
export * from "./BuilderViewer.vue?vue&type=script&lang=js&"
import style0 from "./BuilderViewer.vue?vue&type=style&index=0&id=0e8de7fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8de7fe",
  null
  
)

export default component.exports